import { render, staticRenderFns } from "./MsTooltip2.vue?vue&type=template&id=2d533bd8"
import script from "./MsTooltip2.vue?vue&type=script&lang=js"
export * from "./MsTooltip2.vue?vue&type=script&lang=js"
import style0 from "./MsTooltip2.vue?vue&type=style&index=0&id=2d533bd8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports